import { render, staticRenderFns } from "./GoodsIssueDisplayView.vue?vue&type=template&id=f5a44e2a"
import script from "./GoodsIssueDisplayView.vue?vue&type=script&lang=js"
export * from "./GoodsIssueDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports